import styled from "styled-components";

const MobileTopBarStyled = styled.header`
    background-color: ${props => props.theme.heritageGreen};
    height: 5.6rem;
    width: 100%;
    margin: 0;
    padding: 1.2rem 1.6rem;
	display: flex;

	.header__mobile-controls {
		min-height: auto;
	}

	.m59 {
		display: flex !important;
		z-index: 2;

		&__trigger {
        	background-color: inherit;

			span {
				margin-bottom: 0.5rem;
			}

			span:before {
				vertical-align: middle;
			}
    	}

		&__mobile-logout {
			display: flex;
			align-items: center;
			width: 100%;
			margin: 0;
			font-size: 1.5rem;
			color: ${props => props.theme.heritageGreen};
			border-top: 1px solid ${props => props.theme.lightGray5};
			padding: 1.6rem 1.6rem 1.2rem;

			&:before {
				content: "";
				display: inline-block;
				background-image: url('data:image/svg+xml,<svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 3a3 3 0 0 1 3-3h5a1 1 0 0 1 0 2H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5a1 1 0 1 1 0 2H3a3 3 0 0 1-3-3V3Zm4 4a1 1 0 0 1 1-1h5.585L9.293 4.707a1 1 0 1 1 1.415-1.414l2.996 3a1 1 0 0 1 0 1.414l-2.997 3a1 1 0 1 1-1.414-1.414L10.585 8H5a1 1 0 0 1-1-1Z" fill="%23008755"/></svg>');
				background-repeat: no-repeat;
				height: 1.4rem;
				width: 1.4rem;
				margin-right: 1rem;
			}
		}

		a {
			text-decoration: none;
		}
	}

	.header__basket {
		display: flex;
		align-items: center;
		justify-content: center;

		&, a {
			margin: 0;
		}

		a {
			background-position: center;
		}
	}

	.header__utility-search {
		margin-left: 0;
		width: 3rem;
		margin-right: 2.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 3rem;
		width: 3rem;
	}

	.header__mobile-controls {
		align-items: center;
	}

	.header__basket,
	.m59 {
		height: 3rem;
    	width: 3rem;
		margin-right: 2.4rem;
	}
`;

export { 
	MobileTopBarStyled
 };
